import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { forwardRef } from 'react';
import styled from 'styled-components';
import { typographyTemplate } from '@equinor/eds-utils';
import { label } from './Label.tokens.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var _excluded = ["label", "meta", "disabled"];
var LabelBase = styled.label.withConfig({
  displayName: "Label__LabelBase",
  componentId: "sc-1gi2bcn-0"
})(["display:flex;justify-content:space-between;position:relative;", " margin-left:", ";margin-right:", ";color:", ";"], typographyTemplate(label.typography), label.spacings.left, label.spacings.right, function (_ref) {
  var $disabledText = _ref.$disabledText;
  return $disabledText ? label.states.disabled.typography.color : label.typography.color;
});
var Text = styled.span.withConfig({
  displayName: "Label__Text",
  componentId: "sc-1gi2bcn-1"
})(["margin:0;"]);
var Label = /*#__PURE__*/forwardRef(function Label(props, ref) {
  var _props$label = props.label,
    label = _props$label === void 0 ? '' : _props$label,
    meta = props.meta,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    other = _objectWithoutProperties(props, _excluded);
  return (
    /*#__PURE__*/
    /*  @TODO: Other props spread has to be at the end for downshift to create the for attribute */
    jsxs(LabelBase, _objectSpread(_objectSpread({
      ref: ref,
      $disabledText: disabled
    }, other), {}, {
      children: [/*#__PURE__*/jsx(Text, {
        children: label
      }), meta && /*#__PURE__*/jsx(Text, {
        children: meta
      })]
    }))
  );
});

// Label.displayName = 'eds-text-field-label'

export { Label };
